/**
* @author lmcarrillo <lmcarrillo@sergas.net>
* @copyright Boqueixon 2023
* @version 20.60.60
* @license licenses.txt
*
* @date 2023-03-19 12:47:50
**/

import { Component , OnInit } from "@angular/core";
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from "@angular/router";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { environment } from "./../../../../src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { Globals } from "../../class/globals/globals";
import { TranslateConfiguration } from "../../class/translate-configuration/translate-configuration";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import { PostsService } from "./../../services/posts/posts.service";
import { CategoriesService } from "./../../services/categories/categories.service";
import { PopoverController } from "@ionic/angular";
import { PopoverComponent } from "../../components/popover/popover.component";



@Component({
	selector: "app-posts-by-author",
	templateUrl: "posts-by-author.page.html",
	styleUrls: ["posts-by-author.page.scss"],
})

export class PostsByAuthorPage {

	//url parameter
	public dataId : string;


	// search query
	filterQuery: string = "";

	
	pageName:string = `posts-by-author` ;
	
	/**
	* PostsByAuthorPage:constructor()
	**/
	constructor(
		private router: Router,
		public statusBar: StatusBar,
		public translateService: TranslateService,
		public postsService: PostsService,
		public categoriesService: CategoriesService,
		public popoverController: PopoverController,
		public activatedRoute: ActivatedRoute,
		private storage: Storage,
		private globals: Globals,
		private translateConfiguration: TranslateConfiguration
	){
	
		// statusbar
		this.statusBar.styleLightContent();
		this.statusBar.overlaysWebView(false);
		this.statusBar.backgroundColorByHexString("#e6e6e6");
	
		// translate
		this.translateConfiguration.setDefaultLanguage();

	
	
		this.dataId = this.activatedRoute.snapshot.paramMap.get("data_id");
		//badge for bookmarks
		this.createBadge();
		

		console.log(`PostsByAuthorPage`,`pageName`,this.pageName);
	}
	
	/**
	* PostsByAuthorPage:showPopover()
	**/
	async showPopover(ev: any) {
		const popover = await this.popoverController.create({
			component: PopoverComponent,
			event: ev,
			translucent: true
		});
		return await popover.present();
	}
	
	


		
	
	posts: Observable<any>;
	dataPosts: any = [];
	
	pageNumber: number = 1;
	query = {};
	
	/**
	* getPosts()
	**/
	getPosts(start: boolean){
		this.updateQuery();
		this.posts = this.postsService.getPosts(this.query);
		this.posts.subscribe(data => {
			if(start == true){
				this.dataPosts = data ;
			}else{
				this.dataPosts = this.dataPosts.concat(data);
			}
		});
	}
	
	
	/**
	* loadMore(infiniteScroll)
	* @param event $infiniteScroll
	**/
	public loadMore(infiniteScroll){
		let pageNumber = this.pageNumber;
		this.pageNumber++;
		this.getPosts(false);
		setTimeout(() => {
			infiniteScroll.target.complete();
			//infiniteScroll.target.enable = false;
		}, 500);
	}
	
	
	/**
	* updateQuery()
	**/
	public updateQuery(){
		this.query["page"] = this.pageNumber;
		this.query["_embed"] = "true";
		this.query["per_page"] = 10 ;
		this.query["search"] = this.filterQuery;
		if(this.dataId){
			this.query["author"] = this.dataId;
		}
		console.log("parameter",this.query);
	}
	
	
	/**
	* doRefresh()
	**/
	public doRefresh(refresher){
		this.dataPosts = [];
		this.getPosts(false);
		setTimeout(() => {
			refresher.target.complete();
		}, 2000);
	}
	
	
	
	/**
	* filterItems($event)
	* @param any $event
	**/
	public filterItems(evt: any){
		let filterVal = evt.target.value;
		if (filterVal && filterVal.trim() !== "") {
			this.filterQuery = filterVal;
		}else{
			this.filterQuery = "";
		}
		if((this.filterQuery.length == 0 ) || (this.filterQuery.length >= 3 )){
			this.dataPosts = [];
			this.pageNumber = 1;
			this.getPosts(true);
		}
	}
	
	
	/**
	* ngOnInit()
	**/
	public ngOnInit(){
		this.dataPosts = [];
		this.pageNumber = 1;
		this.getPosts(true);
	}
	
	
	//create badge on tab menu
	count_bookmarks:number = 0;
	temp_count_bookmarks:number = 0 ;
	item_bookmarks : any = [];
	
	runBadge: any;
	
	
	/**
	* PostsByAuthorPage:createBadge()
	**/
	createBadge(){
		this.runBadge = setInterval(()=>{
			this.getBadges();
		},1000)
	}
	
	
	/**
	* PostsByAuthorPage:ionViewDidLeave()
	**/
	ionViewDidLeave(){
		clearInterval(this.runBadge);
	}
	
	
	/**
	*  PostsByAuthorPage.getBookmark()
	**/
	public async getBookmark(){
		this.count_bookmarks = this.temp_count_bookmarks;
		this.temp_count_bookmarks = 0;
		this.item_bookmarks = []; 
		this.storage.forEach((iValue, iKey, iIndex) => {
			if(iKey.substring(0,10) ==  `bookmarks:`){
				this.pushBookmark(iValue);
			}
		});
	}
	
	
	/**
	* PostsByAuthorPage.pushBookmark(item)
	**/
	private pushBookmark(item){
		this.temp_count_bookmarks++;
		this.item_bookmarks.push(item);
	}
	
	
	/**
	* PostsByAuthorPage:getBadges()
	**/
	getBadges(){
		this.getBookmark();
	}
	
	




}
